<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <!--Section: Intro-->
    <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
      <strong>Solicitudes</strong>
    </h2>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade">
          <!--Card image-->
          <div class="price white-text rounded-top"></div>
          <!--/Card image-->

          <div>
            <mdb-tbl class="table-st">
              <mdb-tbl-head class="HeadBG" responsive>
                <tr>
                  <th scope="col"># Obra</th>
                  <th scope="col" style="width: 25%;">Nombre de la obra</th>
                  <th scope="col">Número de solicitudes</th>
                  <th scope="col">Estatus</th>
                  <th scope="col">Acciones</th>
                </tr>
              </mdb-tbl-head>
              <mdb-tbl-body>
                <tr v-for="item in workersList" v-bind:key="item.uuid">
                  <td>{{item.construction.number}}</td>
                  <td>{{item.construction.name}}</td>
                  <td>
                    <div v-if="item.pending > 0" class="tooltip-p">
                      <a
                        :href="'./workers?construction='+item.construction.uuid"
                        style=" color: cornflowerblue; text-decoration: underline;"
                      >{{item.workers}}</a>
                      <span class="tooltiptext">Ver trabajadores pedientes</span>
                    </div>
                    <div v-else>{{item.workers}}</div>
                  </td>
                  <td>
                    <div>
                      <ul
                        class="list-group list-group-horizontal-sm"
                        style="font-size: 13px; margin-top: -0.5rem;"
                      >
                        <li
                          class="list-group-item d-flex justify-content-between align-items-center"
                          style="border: 0px;"
                        >
                          Aprobados&nbsp;&nbsp;
                          <span
                            class="badge badge-success"
                            style="background-color: #28a745 !important;"
                          >{{item.approved}}</span>
                        </li>
                        <li
                          class="list-group-item d-flex justify-content-between align-items-center"
                          style="border: 0px;"
                        >
                          Rechazados&nbsp;&nbsp;
                          <span class="badge badge-danger">{{item.rejected}}</span>
                        </li>
                        <li
                          class="list-group-item d-flex justify-content-between align-items-center"
                          style="border: 0px;"
                        >
                          Pendientes&nbsp;&nbsp;
                          <span class="badge badge-warning">{{item.pending}}</span>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td>
                    <div>
                      <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                        <span slot="tip">Aprobar todo</span>
                        <mdb-btn
                          slot="reference"
                          outline="white"
                          rounded
                          size="sm"
                          class="px-2 button_background"
                          @click="approveAll(item.construction.uuid)"
                        >
                          <mdb-icon icon="check" class="mt-0" />
                        </mdb-btn>
                      </mdb-tooltip>
                      <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                        <span slot="tip">Rechazar todo</span>

                        <mdb-btn
                          slot="reference"
                          outline="white"
                          rounded
                          size="sm"
                          class="px-2 ml-2 button_background"
                          style="width: 2rem;"
                          @click="rejectAll(item.construction.uuid)"
                        >
                          <mdb-icon icon="times" />
                        </mdb-btn>
                      </mdb-tooltip>
                    </div>
                  </td>
                </tr>
              </mdb-tbl-body>
            </mdb-tbl>

            <nav aria-label="Page navigation example">
              <ul class="pagination pg-blue justify-content-center">
                <li class="page-item">
                  <a
                    v-if="page != 1"
                    class="page-link Trazado-295"
                    @click="page--"
                    tabindex="-1"
                  >&laquo;</a>
                </li>
                <li class="page-item" v-for="pageNumber in pages.slice(page-1, page+5)" :key="pageNumber">
                  <a class="page-link Trazado-295" @click="page = pageNumber">{{pageNumber}}</a>
                </li>
                <li class="page-item">
                  <a
                    v-if="page < pages.length"
                    @click="page++"
                    class="page-link Trazado-295"
                  >&raquo;</a>
                </li>
              </ul>
            </nav>
          </div>

          <!--Bottom Table UI-->
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
  </mdb-container>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import * as firebase from 'firebase/app'
import 'firebase/database'
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbCardText,
  mdbSelect,
  mdbBtn,
  mdbTooltip,
  mdbIcon,
  mdbCardHeader,
  mdbInput,
  mdbAvatar,
  mdbTbl,
  mdbTblHead,
  mdbTblBody
} from "mdbvue";

export default {
  name: "Requests",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardText,
    mdbSelect,
    mdbBtn,
    mdbTooltip,
    mdbIcon,
    mdbCardHeader,
    mdbInput,
    mdbAvatar,
    mdbTbl,
    mdbTblHead,
    mdbTblBody
  },
  data() {
    return {
      page: 1,
      perPage: 20,
      pages: [],
      numberOfPages: 0,
      workersList: []
    };
  },
  methods: {
    reject(uuid) {
      Axios.put(
        Servers.serverApi + "/api/constructionWorkers/" + uuid + "/reject",
        "Rechazado",
        {
          responseType: "application/json",
          headers: {
            "Content-Type": "text/plain",
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {})
        .catch(error => {
          aux.showMessageError("Solicitud no completada", error.response.data);
        });

      /*if (status == "Pendiente") {
        var data = {};
        Swal.fire({
          title: "<span style='font-size: 20px;'>Cargando...</span>",
          width: "30%",
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });
        Axios.put(
          Servers.serverApi +
            "api/constructionWorkerRequests/" +
            uuid +
            "/reject",
          "Rechazado",
          {
            responseType: "application/json",
            headers: {
              "Content-Type": "text/plain",
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          }
        )
          .then(function(response) {
            Swal.fire({
              title:
                "<span style='font-size: 20px;'>¡Solicitudes rechazadas correctamente!</span>",
              type: "success",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              },
              onBeforeOpen: () => {
                Swal.hideLoading();
              },
              onClose: () => {
                window.location.reload();
              }
            });
          })
          .catch(error => {
            Swal.fire({
              title:
                "<span style='font-size: 20px'>¡Acción no completada!</span>",
              html:
                "<span style='font-size: 12px'>" +
                error.response.data +
                "</span>",
              imageUrl:
                Servers.serverImg + "apps/myfrac/admin/assets/Cancel_icon.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              //confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              },
              onBeforeOpen: () => {
                Swal.hideLoading();
              },
              onClose: () => {}
            });
          });
      } else {
        Swal.fire({
          title:
            "<span style='font-size: 14px;'>Esta solicitud ya fue <strong>\"" +
            status +
            '"</strong></span>',
          type: "info",
          width: "30%",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn-modal-accept"
          }
        });
      }*/
    },
    rejectAll(uuidConstruction) {
      let aux = this;
      var workersList2 = [];

      Axios.get(
        Servers.serverApi +
          "api/constructionWorkers/construction?construction=" +
          uuidConstruction,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          workersList2 = response.data.filter(
            item => item.status === "Pendiente"
          );
          if (workersList2.length > 0) {
            Swal.fire({
              title: "<span style='font-size: 20px;'>Cargando...</span>",
              width: "30%",
              allowOutsideClick: false,
              onBeforeOpen: () => {
                Swal.showLoading();
              }
            });
            workersList2.map(function(value, index) {
              aux.reject(value.uuid);
            });
            aux.deleteRequestFireBase(uuidConstruction);
            Swal.fire({
              title:
                "<span style='font-size: 20px;'>¡Solicitudes rechazadas correctamente!</span>",
              type: "success",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              },
              onBeforeOpen: () => {
                Swal.hideLoading();
              },
              onClose: () => {
                window.location.reload();
              }
            });
          } else {
            Swal.fire({
              title:
                "<span style='font-size: 14px;'>No hay solicitudes pendientes</span>",
              type: "info",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              }
            });
          }
        })
        .catch(error => {
         
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    deleteRequestFireBase(uuidConstruction){
      // var auxMe = JSON.parse(localStorage.getItem('me'));
      // firebase.database().ref('workers/'+auxMe.idFrac+'/'+uuidConstruction+'/').remove();

    },
    approveAll(uuidConstruction) {
      let aux = this;
      var workersList2 = [];
      Axios.get(
        Servers.serverApi +
          "api/constructionWorkers/construction?construction=" +
          uuidConstruction,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      ).then(function(response) {
          workersList2 = response.data.filter(
            item => item.status === "Pendiente"
          );
          if (workersList2.length > 0) {
            Swal.fire({
              title: "<span style='font-size: 20px;'>Cargando...</span>",
              width: "30%",
              allowOutsideClick: false,
              onBeforeOpen: () => {
                Swal.showLoading();
              }
            });
            workersList2.map(function(value, index) {
              aux.approve(value.uuid);
            });
            //aux.deleteRequestFireBase(uuidConstruction);
            Swal.fire({
              title:
                "<span style='font-size: 20px;'>¡Solicitudes aceptadas correctamente!</span>",
              type: "success",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              },
              onBeforeOpen: () => {
                Swal.hideLoading();
              },
              onClose: () => {
                window.location.reload();
              }
            });
          } else {
            Swal.fire({
              title:
                "<span style='font-size: 14px;'>No hay solicitudes pendientes</span>",
              type: "info",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              }
            });
          }
        })
        .catch(error => {
           console.log(error.response.data)
          aux.showMessageError("Ha ocurrido un error", error);
        });
    },
    approve(uuid) {
      var data = {};
      Axios.put(
        Servers.serverApi + "api/constructionWorkers/" + uuid + "/approve",
        data,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      ).then(
        function(response) {
          return;
        },
        function(error) {
          aux.showMessageError("Solicitud no completada", error.response.data);
        }
      );
      /*if (status == "Pendiente") {
        let aux = this;
        var data = {};
        Swal.fire({
          title: "<span style='font-size: 20px;'>Cargando...</span>",
          width: "30%",
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });
        Axios.put(
          Servers.serverApi +
            "api/constructionWorkerRequests/" +
            uuid +
            "/approve",
          data,
          {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          }
        )
          .then(function(response) {
            Swal.fire({
              title:
                "<span style='font-size: 20px;'>¡Solicitudes aceptadas correctamente!</span>",
              type: "success",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              },
              onBeforeOpen: () => {
                Swal.hideLoading();
              },
              onClose: () => {
                window.location.reload();
              }
            });
          })
          .catch(error => {
            Swal.fire({
              title:
                "<span style='font-size: 20px'>¡Acción no completada!</span>",
              html:
                "<span style='font-size: 12px'>" +
                error.response.data +
                "</span>",
              imageUrl:
                Servers.serverImg + "apps/myfrac/admin/assets/Cancel_icon.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              //confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              },
              onBeforeOpen: () => {
                Swal.hideLoading();
              },
              onClose: () => {}
            });
          });
      } else {
        Swal.fire({
          title:
            "<span style='font-size: 14px;'>Esta solicitud ya fue <strong>\"" +
            status +
            '"</strong></span>',
          type: "info",
          width: "30%",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn-modal-accept"
          }
        });
      }*/
    },
    paginate(workersList) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return workersList.slice(from, to);
    },
    getWorkerRequest() {
      let aux = this;

      Axios.get(
        Servers.serverApi + "api/constructionWorkerRequests/byAdministrator",
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          var auxList = [];
          aux.workersList = response.data;

          let group = aux.workersList.reduce((r, a) => {
            r[a.constructionId] = [...(r[a.constructionId] || []), a];
            return r;
          }, {});

          var keys = Object.keys(group);
          var val;

          for (var i = 0; i < keys.length; i++) {
            val = group[keys[i]];
            val[0].workers = val.length;
            var aprovados = 0;
            var rechazados = 0;
            var pendientes = 0;
            val.map(function(value, key) {
              aprovados = aprovados + value.approved;
              rechazados = rechazados + value.rejected;
              pendientes = pendientes + value.pending;
            });
            val[0].approved = aprovados;
            val[0].rejected = rechazados;
            val[0].pending = pendientes;
            auxList.push(val[0]);
            // use val
          }
          aux.workersList = auxList;
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function() {

    }
  },
  mounted() {},
  created() {
    this.getWorkerRequest();
  },
  watch: {},
  computed: {
    workers() {
      return this.paginate(this.workersList);
    }
  }
};
</script>

    

<style scoped>
.btn-outline-white:hover,
.btn-outline-white:focus,
.btn-outline-white:active,
.btn-outline-white:active:focus,
.btn-outline-white.active {
  border-color: #fff !important;
  background-color: rgb(103, 163, 207) !important;
  color: #fff !important;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table > tbody {
  text-align: center;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}
</style>